import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ExternalEventsDirective } from '@zaoblako/web/shared/directives/external-events.directive';
import { MenuItem } from 'primeng/api';
import { Menu, MenuModule } from 'primeng/menu';

@Component({
  selector: 'crm-change-field-in-card',
  standalone: true,
  imports: [CommonModule, ExternalEventsDirective, MenuModule],
  templateUrl: './change-field-in-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeFieldInCardComponent implements OnInit, OnChanges, AfterContentInit {
  @ContentChild('infoTemplate') public readonly infoTemplate: TemplateRef<any>;
  @ContentChild('editTemplate') public readonly editTemplate: TemplateRef<any>;

  @ViewChild('menu', { static: true }) public readonly menu: Menu;

  @Input() public enabledMenu = true;
  @Input() public editFn: () => void;
  @Input() public routeOpen: string;
  @Input() public href: string;

  // Для PrimeNG p-menu: переносит popup в заданный контейнер (например, "body"),
  // чтобы корректно позиционировать меню внутри scroll/overlay-контейнеров.
  @Input() public appendTo: string | HTMLElement | undefined;

  @Input() public elements: HTMLElement | HTMLElement[];

  @Output() public onClickExternal = new EventEmitter<void>();
  @Output() public onShowInfo = new EventEmitter<void>();
  @Output() public onShowEdit = new EventEmitter<void>();

  public isEdit = false;

  public menuItems: MenuItem[] = [
    {
      label: 'Изменить',
      icon: 'pi pi-pencil',
      command: () => {
        this.changeIsEdit();
      }
    },
    {
      label: 'Открыть',
      icon: 'pi pi-external-link',
      target: '_blank'
    }
  ];

  public constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {}

  public getHostElement = (): HTMLElement => this.elementRef.nativeElement;

  public ngOnInit(): void {
    this.elements = this.menu?.el?.nativeElement;
  }

  public ngAfterContentInit(): void {
    this.cdRef.markForCheck();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.editFn?.currentValue) {
      this.menuItems[0].command = () => {
        this.isEdit = true;
        this.onShowEdit.emit();
        this.editFn();
      };
    }
    if (changes.routeOpen?.currentValue) {
      this.menuItems[1].routerLink = this.routeOpen;
    }
    if (changes.href?.currentValue) {
      this.menuItems[1].url = this.href;
    }
    if (changes.elements?.currentValue) {
      setTimeout(() => {
        if (Array.isArray(this.elements)) {
          this.elements = [...this.elements, this.menu?.el?.nativeElement];
        } else {
          this.elements = [this.elements, this.menu?.el?.nativeElement];
        }
      });
    }
  }

  public closeEditPanelWithoutSave(): void {
    this.isEdit = false;
    this.onShowInfo.emit();
    this.cdRef.markForCheck();
  }

  public closeEditPanel(): void {
    this.closeEditPanelWithoutSave();
    this.onClickExternal.emit();
  }

  public changeIsEdit() {
    setTimeout(() => {
      this.isEdit = true;
      this.onShowEdit.emit();
      this.cdRef.markForCheck();
    });
  }
}
